<template>
    <div class="empty-data">
        <span style="top:30px;position: relative;">No Data Available</span>
    </div>
</template>

<script>
export default {
    name:'noDataDiv',
    data() {
        return {
            isLoading:true,
        }
    },
}
</script>

<style>
.empty-data {
    text-align: center;
    max-height: 150px;
    height: 100%;
    font-style: italic;
}
</style>